export default "__VITE_ASSET__mSz$URbC__"